import { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { IconButton, Stack } from "@mui/material";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';

import { TableLayout } from "../../layout/TableLayout"
import { EditVehicle } from "./";
import { selectVehicle } from "../../../store/vehicle/vehicleSlice";
import { deleteVehicle } from "../../helpers/vehicle";

export const VehiclesTable = ({ rows, setReloadData }) => {
    const { t } = useTranslation('global');
    const [openEdit, setOpenEdit] = useState(false);
    const dispatch = useDispatch();

    const onEditClick = (e) => {
        dispatch(selectVehicle(e.row))
        setOpenEdit(true)
    }
    const onDeleteClick = async (e) => {
        await deleteVehicle(e, t('delete.successMsg'), t('delete.errorMsg'), t('delete.cancelButton'), t('delete.confirmButton'), t('delete.deleteConfirm'))
        setReloadData(prevState => !prevState)
    }

    const columns = [
        {
            field: 'name',
            headerName: t('vehiclestable.name'),
            minWidth: 300,
            flex: 1,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'key',
            headerName: t('vehiclestable.key'),
            minWidth: 100,
            flex: 1,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'created',
            headerName: t('vehiclestable.created'),
            minWidth: 140,
            flex: 1,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'modality',
            headerName: t('vehiclestable.modality'),
            minWidth: 120,
            flex: 1,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'holding',
            headerName: t('vehiclestable.holding'),
            minWidth: 200,
            flex: 1,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'address',
            headerName: t('vehiclestable.address'),
            minWidth: 320,
            flex: 1,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'zipCode',
            headerName: t('vehiclestable.zipCode'),
            minWidth: 100,
            flex: 1,
            align: 'center',
            headerAlign: 'center'
        },
        {
            field: 'action',
            headerName: t('partnerlist.columnActions'),
            maxWidth: 90,
            align: 'center',
            headerAlign: 'center',
            flex: 0,
            sortable: false,
            renderCell: (params) => {
                return (<Stack direction='row' gap={0}>
                    <IconButton color='secondary' onClick={() => onEditClick(params)}>
                        <EditRoundedIcon />
                    </IconButton>

                    <IconButton color='secondary' onClick={() => onDeleteClick(params)}>
                        <DeleteOutlineRoundedIcon />
                    </IconButton>
                </Stack>
                )
            }
        }
    ]

    return (
        <>
            <TableLayout
                rows={rows}
                columns={columns}
                title='vehicle'
            />
            {
                openEdit &&
                <EditVehicle setHidden={setOpenEdit} setReloadData={setReloadData} />
            }
        </>
    )
}